import merge from 'lodash-es/merge';
import get from 'lodash-es/get';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultControlStyle(control) {
  const instance = control.instance;
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  if (!getDefaultControlStyle[control.designMode]) {
    getDefaultControlStyle[control.designMode]={};
  }

  if (!getDefaultControlStyle[instance.args.designMode][design]) {
    getDefaultControlStyle[instance.args.designMode][design] = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        top: '8px',
        left: '8px',
        width: '112px',
        height: '16px',
        margin: '0px',
        display: 'inline-block',
        userSelect: 'none',
      }),
      body: {
        normal: merge({}, getDefaultStyle(), {
          display: 'block',
          position: 'absolute',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
          width: '100%',
          height: '100%',
          margin: '0px',
          whiteSpace: 'nowrap',
          overflow: 'visible',
        }),
        hover: {},
        top: {
          textAlign: 'center',
        },
        right: {},
        bottom: {
          textAlign: 'center',
        },
        left: {
          textAlign: 'right',
        },
      },
      hover: {},
      icon: {
        normal: merge({}, getDefaultStyle(), {
          transformOrigin: 'center',
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          boxSizing: 'border-box',
          // backgroundColor: '${schemeBackground}',
          backgroundColor: '${schemeForeground}',
          borderStyle: 'solid',
          // borderColor: '${schemeShade}',
          borderColor: '#888',
          borderWidth: design=='classic'?'2px':'1px',
          borderRadius: '50%',
          // boxShadow: '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          boxShadow: design=='classic'?
            '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px rgba(0,0,0,0.4) inset,  0 2px 3px rgba(0,0,0,0.5) inset'
            :'0px 2px 4px rgba(0,0,0,0.4)',
          display: 'inline-block',
          width: 'auto',
          height: '100%',
          padding: '1px',
        }),
        hover: {
          // backgroundColor: '${schemeBackgroundHover}',
          // boxShadow: '0px 2px 2px rgba(0,0,0,0.4), 0 -8px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          boxShadow: design=='classic'?
            '0px 0px 5px 2px ${schemeShade}, 0 -12px 20px rgba(0,0,0,0.3) inset,  0 2px 3px rgba(0,0,0,0.4) inset'
            :'0px 0px 5px 2px ${schemeShade}',
        },
        top: {},
        right: {},
        bottom: {},
        left: {},
      },
      iconPath: {
        normal: {
          // fill: '${schemeForeground}',
          fill: '${schemeBackground}',
          transitionProperty: 'opacity',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          opacity: 0,
        },
        checked: {
          opacity: 1,
        },
      },
      label: {
        normal: merge({}, getDefaultStyle(), {
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          display: 'none',
          padding: '${schemePaddingTop} calc(${schemeFontSize} / 2)',
          backgroundColor: 'transparent',
          color: '${schemeForeground}',
          textAlign: 'center',
          textShadow: design=='classic'?'0 2px 2px ${schemeShade}':'0 0px 4px ${schemeShade}',
          fontFamily: 'monospace',
          whiteSpace: 'nowrap',
          fontSize: '${schemeFontSize}',
          fontWeight: '${schemeFontWeight}',
          // height: 'calc(${schemePaddingTop} * 2 + ${schemeFontSize})',
          height: '100%',
          overflow: 'hidden',
        }),
        top: {
          display: 'block',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '100%',
          padding: 'calc(${schemeFontSize} / 2)',
          height: 'auto',
        },
        right: {
          display: 'inline-block',
        },
        bottom: {
          height: 'auto',
          display: 'block',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '100%',
          padding: 'calc(${schemeFontSize} / 2)',
          top: '100%',
        },
        left: {
          display: 'inline-block',
        },
      },
    };
  }

  return getDefaultControlStyle[instance.args.designMode][design];
}

export function getDefaultControl() {
  if (!getDefaultControl.source) {
    getDefaultControl.source = document.createElement('div');
    getDefaultControl.source.classList.add('controls');
    getDefaultControl.source.innerHTML =
      '<div class="body"><span class="label"></span>' +
      '<svg class="icon" viewBox="0 0 24 24">' +
      '<path fill="#000000" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />' + //filter="url(#f3)"
      '</svg>' +
      '<span class="label"></span></div>';
  }

  return getDefaultControl.source.cloneNode(true);
}
